import React from 'react'
import FacturasClientes from '../components/FacturasClientes'

const facturasClientes = () => {
  return (
    <FacturasClientes />
  )
}

export default facturasClientes